<template>
    <div class="analysis-big">
        <div class="analysis-big-left img-scale-in">
            <a :href="$store.state.hrefPrefix + '/articles/' + article.slug"><img v-if="article.blob" :src="article.blob.url" alt=""></a>
        </div>
        <div class="analysis-big-right">
            <h2><a :href="$store.state.hrefPrefix + '/category/' + article.category.slug">{{ article.category.category_languages[0].pivot.name }}</a></h2>
            <h3><a :href="$store.state.hrefPrefix + '/articles/' + article.slug">{{ article.article_languages[0].pivot.title }}</a></h3>
            <p>{{article.article_languages[0].pivot.description }}</p>
        <ul>
            <li v-if="article.second_author == null"><span v-if="!hideAuthor">{{ $t('by') }} <b>{{ article.author.author_languages[0].pivot.name }}</b></span></li>
            <li v-else><span v-if="!hideAuthor">{{ $t('by') }} <b>{{ article.author.author_languages[0].pivot.name }}</b> & <b>{{ article.second_author.author_languages[0].pivot.name }}</b></span></li>
            <li>{{ formattedCreatedAt}}</li>
        </ul>
    </div>
</div>
</template>

<script>
export default {
    name: "CategoryBigFeatureArticle",
    props: {
        article: {
            type: Object,
            default: null
        },
        hideAuthor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date((this.article.published_at ?? this.article.created_at).replace(' ', 'T'));
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            let locale = 'en-US';
            switch (this.$store.state.language.code) {
                case 'ar':
                    locale = 'ar-LB';
                    break;
                case 'tr':
                    locale = 'tr-TR';
                    break;
            }
            return date.toLocaleDateString(locale, options).toUpperCase();
        }
    }
}
</script>

<style scoped>

</style>
